<template>
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M18.1579 9.63158L6.78948 21H3L3 17.2105L14.3684 5.84211M18.1579 9.63158L14.3684 5.84211M18.1579 9.63158L19.8686 7.92085C20.2647 7.52483 20.4627 7.32682 20.5369 7.09849C20.6021 6.89765 20.6021 6.6813 20.5369 6.48046C20.4627 6.25213 20.2647 6.05412 19.8686 5.65811L18.3419 4.13137C17.9459 3.73536 17.7479 3.53735 17.5195 3.46316C17.3187 3.3979 17.1024 3.3979 16.9015 3.46316C16.6732 3.53735 16.4752 3.73536 16.0792 4.13137L14.3684 5.84211"
            stroke="#9AA1AE"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
